import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getCgu } from "@/lib/cguText";

export default function Conditions() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const goBack = () => navigate("/?auth=register");
  const cgu = getCgu(i18n.language);
  return (
    <div className="min-h-[100dvh]">
      <div className="glass sticky top-0 z-40 border-b border-white/10" style={{ paddingTop: "env(safe-area-inset-top)" }}>
        <div className="relative mx-auto flex max-w-3xl items-center justify-center px-5 py-3">
          <Logo size="md" />
          <button onClick={goBack} className="absolute left-4 top-1/2 flex -translate-y-1/2 items-center gap-1 text-sm text-muted-foreground hover:text-foreground" data-testid="conditions-back">
            <ArrowLeft size={16} /> {t("conditions.back")}
          </button>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-5 py-8" data-testid="conditions-page">
        <div className="text-center">
          <h1 className="text-2xl font-semibold tracking-tight" data-testid="conditions-title">{cgu.title}</h1>
          <p className="mt-1 text-sm font-medium text-sky-300">{cgu.subtitle}</p>
        </div>

        <p className="mt-6 whitespace-pre-line rounded-2xl border border-white/10 bg-card/40 px-4 py-4 text-sm font-light leading-relaxed text-foreground/90" data-testid="conditions-intro">
          {cgu.intro}
        </p>

        <div className="mt-8 space-y-7 text-sm font-light leading-relaxed text-foreground/90" data-testid="conditions-content">
          {cgu.articles.map((a, i) => (
            <section key={i} data-testid={`conditions-article-${i + 1}`}>
              <h2 className="mb-2 text-base font-semibold text-sky-300">{a.t}</h2>
              <p className="whitespace-pre-line">{a.p}</p>
            </section>
          ))}
        </div>

        <p className="mt-10 text-center text-xs font-medium tracking-wide text-muted-foreground" data-testid="conditions-footer">{cgu.footer}</p>

        <Button className="mt-6 w-full rounded-full" onClick={goBack} data-testid="conditions-back-btn">{t("conditions.back")}</Button>
      </div>
    </div>
  );
}
